// generate Vancouver standard citation format

function getVancouverEdition(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'edition') ? `(${tags.edition.join(', ')})` : '';
}
function getVancouverAuthors(tags) {
    if (!Object.prototype.hasOwnProperty.call(tags, 'author')) {
        return '';
    }
    const authors = [];
    $.each(tags.author, (index, value) => {
        value = vancouverFormatName(value);
        authors.push(value);
    });
    return authors.join(', ');
}
function getVancouverCountry(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'country') ? `${tags.country.join(', ')}: ` : '';
}
function getVancouverPublisher(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'publisher') ? tags.publisher.join(', ') : '';
}
function getVancouverPublicationDate(issue) {
    return Object.prototype.hasOwnProperty.call(issue, 'publication_date') ? `${issue.publication_date}` : '';
}
function getVancouverTitle(issue, title, localizations) {
    return Object.prototype.hasOwnProperty.call(issue, 'title') && issue.title.length
        ? `${issue.title} [${localizations.citation.messages.online}]`
        : `${title} [${localizations.citation.messages.online}]`;
}
function getVancouverIssueUrl(issue, currentLocation, isEpub = false, localizations) {
    const location = isEpub ? btoa(JSON.stringify(currentLocation)) : currentLocation;
    return Object.prototype.hasOwnProperty.call(issue, 'issue_url') > 0
        ? `${localizations.citation.messages.availableIn}: ${issue.issue_url}?location=${location}`
        : '';
}
function getVancouverCitationGeneratedDate(localizations) {
    const generatedDate = generatedDateFormat(new Date());
    return ` [${localizations.citation.messages.generated} ${generatedDate}]`;
}
function formatValue(string, punctuation = null) {
    punctuation = punctuation ? punctuation : '.';
    const trimmedString = string.trim();
    if (!trimmedString) {
        return '';
    }
    return trimmedString.endsWith(punctuation) ? `${trimmedString} ` : `${trimmedString}${punctuation} `;
}
function vancouverFormatName(name) {
    return name.replace(/^(.+?) ([^\s,]+)(,? (?:[JS]r\.?|III?|IV))?$/i, '$2 $1$3');
}
function generatedDateFormat(date) {
    const month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    const month_index = date.getMonth();
    const year = date.getFullYear();
    return `${day} ${month_names[month_index]} ${year}`;
}

const VancouverCitation = (text, issue, currentLocation, issueTitle, isEpub, localizations) => {
    const author = getVancouverAuthors(issue.tags);
    const date = getVancouverPublicationDate(issue);
    const generatedDate = getVancouverCitationGeneratedDate(localizations);
    const title = getVancouverTitle(issue, issueTitle, localizations);
    const _edition = getVancouverEdition(issue.tags);
    const country = getVancouverCountry(issue.tags);
    const publisher = getVancouverPublisher(issue.tags);
    const url = getVancouverIssueUrl(issue, currentLocation, isEpub, localizations);

    const citation = `${formatValue(author)}${formatValue(title)}${formatValue(country, ':')}${formatValue(publisher, ',')}${formatValue(
        date + generatedDate
    )}${url}`;

    if (text && text.trim()) {
        return `"${text}"

${citation}`;
    }

    return citation;
};

export default VancouverCitation;
